import { render, staticRenderFns } from "./EnpsLowRatingsList.vue?vue&type=template&id=10e7dcf3"
import script from "./EnpsLowRatingsList.vue?vue&type=script&lang=js"
export * from "./EnpsLowRatingsList.vue?vue&type=script&lang=js"
import style0 from "./EnpsLowRatingsList.vue?vue&type=style&index=0&id=10e7dcf3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports